import DynamicUIContext from '@Contexts/DynamicUIContext';
import { useState, ReactNode, FC, PropsWithChildren } from 'react';

const uuid = () => Math.random().toString(36).substring(2, 9);

interface UIElement {
    id: string;
    node: ReactNode;
}

const DynamicUIProvider: FC<PropsWithChildren> = ({ children }) => {
    const [elements, setElements] = useState<UIElement[]>([]);

    const open = (render: (onClose: () => void) => ReactNode) => {
        const id = uuid();
        const close = () => {
            setElements(prev => prev.filter(el => el.id !== id));
        };
        const node = render(close);
        setElements(prev => [...prev, { id, node }]);
    };

    return (
        <DynamicUIContext.Provider value={{ open }}>
            {children}
            {elements.map(el => (
                <div key={el.id}>{el.node}</div>
            ))}
        </DynamicUIContext.Provider>
    );
};

export default DynamicUIProvider;
